import { useSelector, connect } from 'react-redux'

import Button from '~/core/Button'
import Text from '~/core/Text'
import { openModal } from '~/redux-modules/modals'
import PremiumTag from '../../pages/Quotes/Builder/QuoteDetailPage/PremiumTag'

import { selectFlags } from './logic'

const PLACEMENT = 'top-nav'

const GetEarlyAccessTeamsBtn = (props: { openModal: Function }) => {
    const { isGetEarlyAccessTeamsFlagEnabled, identity } =
        useSelector(selectFlags)
    const { businessAccountMembership } = identity

    if (!isGetEarlyAccessTeamsFlagEnabled) {
        return null
    }
    return (
        <Button
            name="get-early-access-to-teams"
            onClick={() => {
                props.openModal('UPSELL')
            }}
            placement={PLACEMENT}
            style={{
                padding: '4px 12px',
                height: '34px',
                fontWeight: 500,
                marginRight: businessAccountMembership ? '8px' : '16px',
            }}
        >
            <Text color="blackAlpha65" style={{ marginRight: '5px' }}>
                Try
            </Text>
            <PremiumTag isPremiumIconOnly={true} />
        </Button>
    )
}

function mapStateToProps() {
    return {
        openModal,
    }
}

export default connect(mapStateToProps, { openModal })(GetEarlyAccessTeamsBtn)
